import React, { useEffect, useState } from 'react'
import { FileText, FileSearch, Layers3, ClipboardList } from 'lucide-react'
import AIAgentOrbLoader from '../../../AIAgentOrb/AIAgentOrbLoader.tsx'
import orbStyles from '../../../AIAgentOrb/AIAgentOrbLoader.module.scss'
import styles from './DocumentPipelineLoopLoader.module.scss'

const STEP_MS = 2600

const STEPS = [
  { label: 'Recibimos tu PDF', Icon: FileText },
  { label: 'Leyendo páginas y tablas', Icon: FileSearch },
  { label: 'Detectando rubros en el documento', Icon: Layers3 },
  { label: 'Armando la propuesta del borrador', Icon: ClipboardList }
] as const

const DocumentPipelineLoopLoader: React.FC = () => {
  const [phase, setPhase] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => {
      setPhase((p) => (p + 1) % STEPS.length)
    }, STEP_MS)
    return () => window.clearInterval(id)
  }, [])

  return (
    <div className={styles.wrap} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.shimmerRail} aria-hidden>
        <div className={styles.shimmer} />
      </div>
      <div className={styles.header}>
        <AIAgentOrbLoader status="thinking" className={`${orbStyles.thinkingOrb} ${styles.orb}`} />
        <div className={styles.headerText}>
          <span className={styles.title}>Analizando documentación</span>
        </div>
      </div>
      <ol className={styles.steps}>
        {STEPS.map(({ label, Icon }, i) => {
          const active = i === phase
          return (
            <li
              key={label}
              className={`${styles.step} ${active ? styles.stepActive : ''}`}
              aria-current={active ? 'step' : undefined}
            >
              <span className={styles.stepIcon} aria-hidden>
                <Icon size={18} strokeWidth={1.85} />
              </span>
              <span className={styles.stepLabel}>{label}</span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export default DocumentPipelineLoopLoader
